<main class="layout">
  <navbar></navbar>
  <sidebar></sidebar>
  <div class="layout-cont">
    <section class="content">
      <div class="content__container">
        <router-outlet></router-outlet>
      </div>
      <add-alert-fb
        *hasPermissions="'alarms'; for: ['create']"
      />
    </section>
  </div>
</main>
<alarm-emitter
  *hasPermissions="'alarms'; for: ['view']"
/>
